export const prefix = 'Mandates/New';
